/** Tailwind default breakpoints — keep in sync with design-system/tailwind.config.cjs */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
} as const;
